import {Types} from "../../../type/Types";

export type ShoppingFunnelValueObject = {
    id: bigint;
    shoppingId: bigint;
    adminId: bigint | null;
    isActive: boolean;
    exposedAt: Date;
    catalogRank: number | null;
    mid: string | null;
    reviewCount: number | null;
    reviewScore: number | null;
    mallCount: number | null;
    storeName: string | null;
    productName: string | null;
    productImageUrl: string | null;
    productNumber: string | null;
    answer: string | null;
    productPrice: bigint | null;
    productUrl: string | null;
    mainKeywordString: string | null;
    mallSequence: string | null;
    categoryId: string | null;
    catalogMid: string | null;
    catalogProductName: string | null;
    catalogLowestPrice: bigint | null;
    catalogDiscountedPrice: bigint | null;
    catalogDeliveryFee: bigint | null;
    amount: bigint | null;
    amountBeforeRefresh: bigint | null;
    successCount: bigint;
    failureCount: bigint;
    reportCount: bigint;
    postBackSuccessCount: bigint;
    verifiedPostBackCount: bigint | null;
    unverifiedPostBackCount: bigint | null;
    missionClickCount: bigint;
    clipBoardClickCount: bigint;
    shoppingAnswerSubmitClickCount: bigint;
    shoppingParticipationMethodClickCount: bigint;
    landingCount: bigint;
    shoppingParticipationSuccessPageLandingCount: bigint;
    shoppingExhaustedPageLandingCount: bigint;
    shoppingTodayParticipationLimitPageLandingCount: bigint;
    shoppingRewardFailurePageLandingCount: bigint;
    shoppingServerErrorPageLandingCount: bigint;
    deactivatedPathJointCount: bigint;
    activatedPathJointCount: bigint;
    createdAt: Date;
    modifiedAt: Date | null;
    crawlerHandledAt: Date | null
    deletedAt: Date | null;
}

export namespace ShoppingFunnelValueObject {
    export function construct(o: any): ShoppingFunnelValueObject {

        return {
            id: BigInt(o.id),
            shoppingId: BigInt(o.shoppingId),
            adminId: Types.asNull(o.adminId, BigInt),
            isActive: Boolean(o.isActive),
            exposedAt: new Date(o.exposedAt),
            catalogRank: Types.asNull(o.catalogRank, Number),
            mid: Types.asNull(o.mid, String),
            reviewCount: Types.asNull(o.reviewCount, Number),
            reviewScore: Types.asNull(o.reviewScore, Number),
            mallCount: Types.asNull(o.mallCount, Number),
            storeName: Types.asNull(o.storeName, String),
            productName: Types.asNull(o.productName, String),
            productImageUrl: Types.asNull(o.productImageUrl, String),
            productNumber: Types.asNull(o.productNumber, String),
            answer: Types.asNull(o.answer, String),
            productPrice: Types.asNull(o.productPrice, BigInt),
            productUrl: Types.asNull(o.productUrl, String),
            mallSequence: Types.asNull(o.mallSequence, String),
            categoryId: Types.asNull(o.categoryId, String),
            catalogMid: Types.asNull(o.catalogMid, String),
            catalogProductName: Types.asNull(o.catalogProductName, String),
            catalogLowestPrice: Types.asNull(o.catalogLowestPrice, BigInt),
            catalogDiscountedPrice: Types.asNull(o.catalogDiscountedPrice, BigInt),
            catalogDeliveryFee: Types.asNull(o.catalogDeliveryFee, BigInt),
            mainKeywordString: Types.asNull(o.mainKeywordString, String),
            amount: Types.asNull(o.amount, BigInt),
            amountBeforeRefresh: Types.asNull(o.amountBeforeRefresh, BigInt),
            successCount: BigInt(o.successCount),
            failureCount: BigInt(o.failureCount),
            reportCount: BigInt(o.reportCount),
            postBackSuccessCount: BigInt(o.postBackSuccessCount),
            verifiedPostBackCount: Types.asNull(o.verifiedPostBackCount, BigInt),
            unverifiedPostBackCount: Types.asNull(o.unverifiedPostBackCount, BigInt),
            missionClickCount: BigInt(o.missionClickCount),
            clipBoardClickCount: BigInt(o.clipBoardClickCount),
            shoppingAnswerSubmitClickCount: BigInt(o.shoppingAnswerSubmitClickCount),
            shoppingParticipationMethodClickCount: BigInt(o.shoppingParticipationMethodClickCount),
            landingCount: BigInt(o.landingCount),
            shoppingParticipationSuccessPageLandingCount: BigInt(o.shoppingParticipationSuccessPageLandingCount),
            shoppingExhaustedPageLandingCount: BigInt(o.shoppingExhaustedPageLandingCount),
            shoppingTodayParticipationLimitPageLandingCount: BigInt(o.shoppingTodayParticipationLimitPageLandingCount),
            shoppingRewardFailurePageLandingCount: BigInt(o.shoppingRewardFailurePageLandingCount),
            shoppingServerErrorPageLandingCount: BigInt(o.shoppingServerErrorPageLandingCount),
            deactivatedPathJointCount: BigInt(o.deactivatedPathJointCount),
            activatedPathJointCount: BigInt(o.activatedPathJointCount),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            crawlerHandledAt: Types.asNull(o.crawlerHandledAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof ShoppingFunnelValueObject, string> = {
        id: 'ID',
        shoppingId: '쇼핑 ID',
        adminId: '관리자 ID',
        isActive: '활성 상태',
        exposedAt: '노출 일자',
        catalogRank: '카탈로그 내 상품 순위',
        mid: '상품 미드값',
        reviewCount: '리뷰 수',
        reviewScore: '별점',
        mallCount: '판매처 수',
        storeName: '스토어 명',
        productName: '상품 명',
        productImageUrl: '상품 이미지 URL',
        productNumber: '상품 번호',
        answer: '미션 정답',
        productPrice: '상품 가격',
        productUrl: '상품 URL',
        mainKeywordString: '메인 키워드 문자열',
        mallSequence: '몰 시퀀스',
        categoryId: '카테고리 ID',
        catalogMid: '카탈로그 상품 미드 값',
        catalogProductName: '카탈로그 상품 명',
        catalogLowestPrice: '카탈로그 상품 최저가',
        catalogDiscountedPrice: '카탈로그 상품 할인된 가격',
        catalogDeliveryFee: '카탈로그 상품 배송비',
        amount: '상품 수량',
        amountBeforeRefresh: '다시 활성화되기 전 수량',
        successCount: '정답 성공 횟수',
        failureCount: '정답 실패 횟수',
        reportCount: '신고 횟수',
        postBackSuccessCount: '포스트백 성공 횟수',
        verifiedPostBackCount: '검증된 포스트백 수',
        unverifiedPostBackCount: '검증 안된 포스트백 수',
        missionClickCount: '미션 하러 가기 클릭 횟수',
        clipBoardClickCount: '클립보드 클릭 횟수',
        shoppingAnswerSubmitClickCount: '쇼핑 정답 제출 버튼 클릭 횟수',
        shoppingParticipationMethodClickCount: '쇼핑 참여 방법 버튼 클릭 횟수',
        landingCount: '미션 페이지 랜딩 횟수',
        shoppingParticipationSuccessPageLandingCount: '쇼핑 참여 미션 성공 페이지 랜딩 횟수',
        shoppingExhaustedPageLandingCount: '쇼핑 소진 페이지 랜딩 횟수',
        shoppingTodayParticipationLimitPageLandingCount: '일일 참여 제한 페이지 랜딩 횟수',
        shoppingRewardFailurePageLandingCount: '적립 실패 페이지 랜딩 횟수 (적립키가 유효하지 않을 때)',
        shoppingServerErrorPageLandingCount: '서버 에러 페이지 랜딩 횟수',
        deactivatedPathJointCount: '비활성화된 Joint 수',
        activatedPathJointCount: '활성화된 Joint 수',
        createdAt: '생성 일자',
        modifiedAt: '수정 일자',
        crawlerHandledAt: '크롤러 응답 데이터 마지막 핸들 일자',
        deletedAt: '삭제 일자',
    }
}